export type Locale = 'it' | 'en' | 'es' | 'fr' | 'de' | 'pt' | 'nl' | 'ru' | 'zh' | 'ja' | 'ko' | 'ar' | 'hi' | 'pl' | 'sv'

export const translations = {
  it: {
    // Common
    loading: 'Caricamento...',
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    close: 'Chiudi',
    back: 'Indietro',
    next: 'Avanti',
    confirm: 'Conferma',
    error: 'Errore',
    success: 'Successo',

    // Navigation
    dashboard: 'Dashboard',
    profile: 'Profilo',
    settings: 'Impostazioni',
    logout: 'Esci',

    // Dashboard
    welcomeBack: 'Bentornato',
    there: 'ciao',
    manageRooms: 'Gestisci le tue stanze e inizia a collaborare',
    yourRooms: 'Le tue stanze',
    createRoom: 'Crea Stanza',
    joinRoom: 'Unisciti',
    noRooms: 'Nessuna stanza disponibile',
    noRoomsFound: 'Nessuna stanza trovata',
    tryAdjusting: 'Prova a modificare la tua ricerca.',
    createToStart: 'Crea una stanza per iniziare.',
    roomsDescription: 'Crea o unisciti a stanze di videoconferenza con traduzione in tempo reale',
    quickStart: 'Avvio Rapido',
    instantMeeting: 'Riunione istantanea',
    newRoom: 'Nuova Stanza',
    scheduleForLater: 'Pianifica per dopo',
    quickInvite: 'Invito Rapido',
    startCallNow: 'Inizia chiamata ora',
    scheduleCall: 'Pianifica Chiamata',
    planForLater: 'Pianifica per dopo',
    search: 'Cerca...',
    public: 'Pubblica',
    private: 'Privata',
    deleteRoom: 'Elimina stanza',
    confirmDelete: 'Sei sicuro di voler eliminare',
    roomDeleted: 'Stanza eliminata',
    failedToDelete: 'Impossibile eliminare la stanza',
    roomCreated: 'Stanza creata con successo!',
    failedToCreate: 'Impossibile creare la stanza',
    roomNameLabel: 'Nome',
    roomNamePlaceholder: 'Sincronizzazione settimanale',
    descriptionLabel: 'Descrizione',
    descriptionPlaceholder: 'Opzionale...',
    publicRoomLabel: 'Stanza Pubblica',
    create: 'Crea',
    inviteGuest: 'Invita Ospite',
    joinCall: 'Unisciti alla Chiamata',
    copy: 'Copia',
    share: 'Condividi',
    admin: 'Admin',
    user: 'Utente',

    // Profile
    profileTitle: 'Il tuo profilo',
    profileDescription: 'Gestisci le tue informazioni personali e preferenze',
    backToDashboard: 'Torna alla Dashboard',
    profileInfo: 'Informazioni Profilo',
    updatePhotoInfo: 'Aggiorna la tua foto e le informazioni personali',
    fullName: 'Nome completo',
    email: 'Email',
    emailManaged: "L'email è gestita da Clerk e non può essere modificata qui",
    preferredLanguage: 'Lingua preferita',
    changePhoto: 'Cambia foto',
    saveChanges: 'Salva modifiche',
    saving: 'Salvataggio...',
    profileUpdated: 'Profilo aggiornato con successo!',
    profileUpdateError: "Errore durante l'aggiornamento del profilo",

    // Referral
    referralCode: 'Codice Referral',
    inviteFriends: 'Invita amici e guadagna crediti bonus',
    shareLink: 'Condividi il tuo link di referral e ricevi',
    creditsPerFriend: '50 crediti',
    perFriend: 'per ogni amico che si iscrive!',
    friendsInvited: 'Amici Invitati',
    creditsEarned: 'Crediti Guadagnati',
    yourReferrals: 'I Tuoi Referral',
    friendsJoinedWithLink: 'Amici che si sono iscritti con il tuo link',
    referrals: 'Referral',
    copied: 'Copiato',
    accountDetails: 'Dettagli Account',

    // Danger Zone
    dangerZone: 'Zona Pericolosa',
    permanentAction: 'Azioni permanenti che non possono essere annullate',
    deleteAccount: 'Elimina Account',
    deleteAccountWarning: 'Elimina permanentemente il tuo account, i dati e tutti i contenuti associati',
    confirmDeleteAccount: 'Conferma Eliminazione Account',
    deleteWarningTitle: 'Questa azione è permanente e non può essere annullata!',
    deleteWarningText: "L'eliminazione del tuo account:",
    deleteWarning1: 'Eliminerà permanentemente tutti i tuoi dati',
    deleteWarning2: 'Rimuoverà tutte le tue stanze e registrazioni',
    deleteWarning3: 'Eliminerà i tuoi cloni vocali',
    deleteWarning4: 'Annullerà il tuo abbonamento (se attivo)',
    typeDeleteConfirm: 'Digita',
    toConfirm: 'per confermare',
    deleting: 'Eliminazione...',
    deleteAccountPermanent: 'Elimina Account Permanentemente',
    typeDeleteToConfirm: 'Digita DELETE per confermare',
    accountDeleted: 'Account eliminato con successo',

    // Account Stats
    accountStats: 'Statistiche Account',
    availableCredits: 'Crediti disponibili',
    trialExpires: 'Trial scade il',
    plan: 'Piano',
    status: 'Stato',
    referralCodeLabel: 'Codice referral',

    // Trial System
    trialSession: 'Sessione Trial',
    trialActive: 'Trial Attivo',
    trialExpired: 'Trial Scaduto',
    daysRemaining: 'giorni rimanenti',
    activateTrial: 'Attiva Trial',
    enterTrialCode: 'Inserisci codice trial',
    activateCode: 'Attiva Codice',
    trialCodePlaceholder: 'TRIAL-XXXXXXXX',
    activating: 'Attivazione...',
    trialActivated: 'Trial attivato con successo!',
    invalidTrialCode: 'Codice trial non valido',
    trialCodeExpired: 'Codice trial scaduto',
    trialCodeAlreadyUsed: 'Codice trial già utilizzato',
    trialEndsOn: 'Termina il',
    upgradeNow: 'Passa a Premium',
    trialExpiredTitle: 'Il tuo periodo di prova è terminato',
    trialExpiredDescription: 'I tuoi 7 giorni di accesso gratuito sono scaduti.',

    // Auth
    signIn: 'Accedi',
    signUp: 'Registrati',
    signOut: 'Disconnetti',
    signedOut: 'Disconnesso con successo',
    signOutError: 'Errore durante la disconnessione',

    // Room
    roomName: 'Nome stanza',
    participants: 'Partecipanti',
    duration: 'Durata',
    active: 'Attiva',
    inactive: 'Inattiva',

    // Credits
    credits: 'Crediti',
    buyCredits: 'Acquista Crediti',
    freeCredits: 'Crediti gratuiti',

    // Languages
    italian: 'Italiano',
    english: 'Inglese',
    spanish: 'Spagnolo',
    french: 'Francese',
    german: 'Tedesco',

    // Admin
    metricsRefreshed: 'Metriche aggiornate',
    autoOn: 'Auto ON',
    autoOff: 'Auto OFF',
    unnamedRoom: 'Stanza senza nome',
    unknownError: 'Errore sconosciuto',

    // Trial Limit Modal
    featureNotAvailable: 'Funzione Non Disponibile',
    trialProfileLimit: 'Le impostazioni del profilo non sono disponibili per gli utenti in prova. Registrati per accedere a tutte le funzionalità!',
    withFullAccount: 'Con un account completo ottieni:',
    customProfile: 'Profilo personalizzato',
    savedRoomsPermanently: 'Stanze salvate permanentemente',
    unlimitedAccess: 'Accesso illimitato',
    prioritySupport: 'Supporto prioritario',
    continueTrial: 'Continua Prova',
    signUpNow: 'Registrati Ora',

    // Toast Messages
    welcomeBackSuccess: 'Bentornato! Accesso eseguito con successo',
    welcomeTrialStarted: 'Benvenuto! La tua prova è iniziata',
    errorActivation: 'Errore durante l\'attivazione',
    connectionError: 'Errore di connessione',
    imageUploadError: 'Errore durante il caricamento dell\'immagine',
    roomCreationError: 'Errore durante la creazione della room',
    trialRoomCreationError: 'Errore durante la creazione della room trial',
    sendingCalendarInvite: 'Invio invito calendario...',
    recordingStarted: 'Registrazione avviata',
    recordingStartError: 'Errore nell\'avvio della registrazione',
    playbackError: 'Errore nella riproduzione',
    recordingDeleted: 'Registrazione eliminata',
    ticketsGenerated: 'ticket generati con successo',
    ticketsGenerationError: 'Impossibile generare i ticket',
    codeCopied: 'Codice copiato negli appunti',
    ticketDeleted: 'Ticket eliminato con successo',
    ticketDeletionError: 'Impossibile eliminare il ticket',
    voiceSavedSuccess: '✅ Voce salvata con successo! Questa è ora la tua voce attiva.',
    profileUpdateErrorAlt: 'Errore nell\'aggiornamento del profilo',

    // UI Labels & Buttons
    schedule: 'Pianifica',
    calendarInviteDescription: 'Genereremo un link di invito al calendario che puoi condividere',
    confirmAndContinue: 'Conferma e Continua',
    loadingAdminDashboard: 'Caricamento dashboard admin...',
    loadingGeneric: 'Caricamento...',

    // Admin Trial Tickets
    ticketsCancelled: '✕ Cancellato',
    completedRegistrations: 'Utenti che hanno completato la registrazione con ticket trial (salvati per contatto futuro)',
    confirmTicketDeletion: 'Sei sicuro di voler eliminare questo ticket?',
    ticketDeletionWarning: 'Questa azione non può essere annullata. Il ticket verrà eliminato permanentemente dal database.',

    // Trial Expired Page
    accountBeingDeleted: 'Account in fase di cancellazione',
    accountDeletionWarning: 'Il tuo account trial verrà automaticamente cancellato. Tutti i dati associati verranno eliminati definitivamente.',

    // Room Errors
    roomConnectionError: 'Si è verificato un errore durante la connessione alla room.',
    ticketActivationError: 'Errore durante l\'attivazione del ticket',
    sessionVerificationError: 'Errore durante la verifica della sessione',

    // API Error Messages
    validationError: 'Errore durante la validazione',
    serverError: 'Errore del server',
    sessionValidationError: 'Errore durante la validazione della sessione',
    internalError: 'Errore interno',
    trialSessionExpired: 'Sessione trial scaduta o cancellata',
    ticketActivationErrorAlt: 'Errore durante l\'attivazione del ticket',
    ticketActivationSuccess: '🎉 Ticket attivato con successo! Il tuo trial durerà 7 giorni.',
    feedbackSaveError: 'Errore nel salvataggio del feedback',
    roomCreationErrorAlt: 'Errore durante la creazione della room',
    trialCleanupError: 'Errore durante la pulizia degli utenti trial',
    internalServerError: 'Errore interno del server',

    // Translation Panel
    translationTitle: 'Traduzione',
    translationFast: 'Veloce',
    translationQuality: 'Qualità',
    translationISpeak: 'Parlo',
    translationSwitching: 'Cambio...',
    translationTranslateTo: 'Traduci in',
    translationStart: 'Avvia Traduzione',
    translationStop: 'Ferma Traduzione',
    translationActivateTitle: 'Attiva la traduzione',
    translationActivateSubtitle: 'Seleziona la tua lingua e quella dell\u2019ospite, poi premi Avvia per iniziare la conversazione tradotta in tempo reale.',
    translationPromptSpeaks: 'parla',
    translationPromptYouSpeak: 'Tu parli',
    translationPromptActivate: 'Attiva la traduzione',
    translationPromptDismiss: 'Non ora',
    translationClonedVoiceActive: 'La tua voce clonata verrà utilizzata.',
    translationNoClonedVoice: 'Nessuna voce clonata — verrà usata una voce predefinita.',
    translationReRecord: 'Registra di nuovo',
    translationRecordVoice: 'Registra voce',
    translationActiveFast: 'Traduzione in corso tramite SeamlessM4T (server, bassa latenza).',
    translationActiveQuality: 'Traduzione in corso tramite Deepgram + Cartesia con la tua voce clonata.',
    translationStsOffline: 'Motore STS offline. Traduzione lato browser (latenza più alta).',

    // Control Bar Tooltips
    tooltipMuteMic: 'Disattiva microfono',
    tooltipUnmuteMic: 'Attiva microfono',
    tooltipSwitchMic: 'Cambia microfono',
    tooltipCameraOff: 'Disattiva videocamera',
    tooltipCameraOn: 'Attiva videocamera',
    tooltipSwitchCamera: 'Cambia videocamera',
    tooltipShareScreen: 'Condividi schermo',
    tooltipStopSharing: 'Interrompi condivisione',
    tooltipTranslation: 'Traduzione',
    tooltipCloseTranslation: 'Chiudi traduzione',
    tooltipLeaveRoom: 'Lascia la stanza',
    tooltipChat: 'Chat',
    tooltipCloseChat: 'Chiudi chat',
    tooltipCopied: 'Copiato!',
    tooltipInvite: 'Invita qualcuno',
    tooltipSubtitlesOn: 'Nascondi sottotitoli',
    tooltipSubtitlesOff: 'Sottotitoli',
    chatNoMessages: 'Nessun messaggio',
    chatPlaceholder: 'Scrivi un messaggio...',
  },

  en: {
    // Common
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    confirm: 'Confirm',
    error: 'Error',
    success: 'Success',

    // Navigation
    dashboard: 'Dashboard',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',

    // Dashboard
    welcomeBack: 'Welcome back',
    there: 'there',
    manageRooms: 'Manage your rooms and start collaborating',
    yourRooms: 'Your rooms',
    createRoom: 'Create Room',
    joinRoom: 'Join',
    noRooms: 'No rooms available',
    noRoomsFound: 'No rooms found',
    tryAdjusting: 'Try adjusting your search.',
    createToStart: 'Create a room to get started.',
    roomsDescription: 'Create or join video conference rooms with real-time translation',
    quickStart: 'Quick Start',
    instantMeeting: 'Instant meeting',
    newRoom: 'New Room',
    scheduleForLater: 'Schedule for later',
    quickInvite: 'Quick Invite',
    startCallNow: 'Start call now',
    scheduleCall: 'Schedule Call',
    planForLater: 'Plan for later',
    search: 'Search...',
    public: 'Public',
    private: 'Private',
    deleteRoom: 'Delete room',
    confirmDelete: 'Are you sure you want to delete',
    roomDeleted: 'Room deleted',
    failedToDelete: 'Failed to delete room',
    roomCreated: 'Room created successfully!',
    failedToCreate: 'Failed to create room',
    roomNameLabel: 'Name',
    roomNamePlaceholder: 'Weekly Sync',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Optional...',
    publicRoomLabel: 'Public Room',
    create: 'Create',
    inviteGuest: 'Invite Guest',
    joinCall: 'Join Call',
    copy: 'Copy',
    share: 'Share',
    admin: 'Admin',
    user: 'User',

    // Profile
    profileTitle: 'Your profile',
    profileDescription: 'Manage your personal information and preferences',
    backToDashboard: 'Back to Dashboard',
    profileInfo: 'Profile Information',
    updatePhotoInfo: 'Update your photo and personal information',
    fullName: 'Full name',
    email: 'Email',
    emailManaged: 'Email is managed by Clerk and cannot be modified here',
    preferredLanguage: 'Preferred language',
    changePhoto: 'Change photo',
    saveChanges: 'Save changes',
    saving: 'Saving...',
    profileUpdated: 'Profile updated successfully!',
    profileUpdateError: 'Error updating profile',

    // Referral
    referralCode: 'Referral Code',
    inviteFriends: 'Invite friends and earn bonus credits',
    shareLink: 'Share your referral link and receive',
    creditsPerFriend: '50 credits',
    perFriend: 'for each friend who signs up!',
    friendsInvited: 'Friends Invited',
    creditsEarned: 'Credits Earned',
    yourReferrals: 'Your Referrals',
    friendsJoinedWithLink: 'Friends who joined with your link',
    referrals: 'Referrals',
    copied: 'Copied',
    accountDetails: 'Account Details',

    // Danger Zone
    dangerZone: 'Danger Zone',
    permanentAction: 'Permanent actions that cannot be undone',
    deleteAccount: 'Delete Account',
    deleteAccountWarning: 'Permanently delete your account, data, and all associated content',
    confirmDeleteAccount: 'Confirm Account Deletion',
    deleteWarningTitle: 'This action is permanent and cannot be undone!',
    deleteWarningText: 'Deleting your account will:',
    deleteWarning1: 'Permanently delete all your data',
    deleteWarning2: 'Remove all your rooms and recordings',
    deleteWarning3: 'Delete your voice clones',
    deleteWarning4: 'Cancel your subscription (if active)',
    typeDeleteConfirm: 'Type',
    toConfirm: 'to confirm',
    deleting: 'Deleting...',
    deleteAccountPermanent: 'Delete Account Permanently',
    typeDeleteToConfirm: 'Type DELETE to confirm',
    accountDeleted: 'Account deleted successfully',

    // Account Stats
    accountStats: 'Account Statistics',
    availableCredits: 'Available Credits',
    trialExpires: 'Trial expires on',
    plan: 'Plan',
    status: 'Status',
    referralCodeLabel: 'Referral code',

    // Trial System
    trialSession: 'Trial Session',
    trialActive: 'Trial Active',
    trialExpired: 'Trial Expired',
    daysRemaining: 'days remaining',
    activateTrial: 'Activate Trial',
    enterTrialCode: 'Enter trial code',
    activateCode: 'Activate Code',
    trialCodePlaceholder: 'TRIAL-XXXXXXXX',
    activating: 'Activating...',
    trialActivated: 'Trial activated successfully!',
    invalidTrialCode: 'Invalid trial code',
    trialCodeExpired: 'Trial code expired',
    trialCodeAlreadyUsed: 'Trial code already used',
    trialEndsOn: 'Ends on',
    upgradeNow: 'Upgrade to Premium',
    trialExpiredTitle: 'Your trial period has ended',
    trialExpiredDescription: 'Your 7-day free access has expired.',

    // Auth
    signIn: 'Sign In',
    signUp: 'Sign Up',
    signOut: 'Sign Out',
    signedOut: 'Signed out successfully',
    signOutError: 'Error signing out',

    // Room
    roomName: 'Room name',
    participants: 'Participants',
    duration: 'Duration',
    active: 'Active',
    inactive: 'Inactive',

    // Credits
    credits: 'Credits',
    buyCredits: 'Buy Credits',
    freeCredits: 'Free credits',

    // Languages
    italian: 'Italian',
    english: 'English',
    spanish: 'Spanish',
    french: 'French',
    german: 'German',

    // Admin
    metricsRefreshed: 'Metrics refreshed',
    autoOn: 'Auto ON',
    autoOff: 'Auto OFF',
    unnamedRoom: 'Unnamed Room',
    unknownError: 'Unknown error',

    // Trial Limit Modal
    featureNotAvailable: 'Feature Not Available',
    trialProfileLimit: 'Profile settings are not available for trial users. Sign up to access all features!',
    withFullAccount: 'With a full account you get:',
    customProfile: 'Custom profile',
    savedRoomsPermanently: 'Permanently saved rooms',
    unlimitedAccess: 'Unlimited access',
    prioritySupport: 'Priority support',
    continueTrial: 'Continue Trial',
    signUpNow: 'Sign Up Now',

    // Toast Messages
    welcomeBackSuccess: 'Welcome back! Successfully logged in',
    welcomeTrialStarted: 'Welcome! Your trial has started',
    errorActivation: 'Error during activation',
    connectionError: 'Connection error',
    imageUploadError: 'Error uploading image',
    roomCreationError: 'Error creating room',
    trialRoomCreationError: 'Error creating trial room',
    sendingCalendarInvite: 'Sending calendar invite...',
    recordingStarted: 'Recording started',
    recordingStartError: 'Error starting recording',
    playbackError: 'Playback error',
    recordingDeleted: 'Recording deleted',
    ticketsGenerated: 'tickets generated successfully',
    ticketsGenerationError: 'Unable to generate tickets',
    codeCopied: 'Code copied to clipboard',
    ticketDeleted: 'Ticket deleted successfully',
    ticketDeletionError: 'Unable to delete ticket',
    voiceSavedSuccess: '✅ Voice saved successfully! This is now your active voice.',
    profileUpdateErrorAlt: 'Error updating profile',

    // UI Labels & Buttons
    schedule: 'Schedule',
    calendarInviteDescription: 'We\'ll generate a calendar invite link you can share',
    confirmAndContinue: 'Confirm and Continue',
    loadingAdminDashboard: 'Loading admin dashboard...',
    loadingGeneric: 'Loading...',

    // Admin Trial Tickets
    ticketsCancelled: '✕ Cancelled',
    completedRegistrations: 'Users who completed registration with trial ticket (saved for future contact)',
    confirmTicketDeletion: 'Are you sure you want to delete this ticket?',
    ticketDeletionWarning: 'This action cannot be undone. The ticket will be permanently deleted from the database.',

    // Trial Expired Page
    accountBeingDeleted: 'Account being deleted',
    accountDeletionWarning: 'Your trial account will be automatically deleted. All associated data will be permanently removed.',

    // Room Errors
    roomConnectionError: 'An error occurred while connecting to the room.',
    ticketActivationError: 'Error activating ticket',
    sessionVerificationError: 'Error verifying session',

    // API Error Messages
    validationError: 'Validation error',
    serverError: 'Server error',
    sessionValidationError: 'Session validation error',
    internalError: 'Internal error',
    trialSessionExpired: 'Trial session expired or cancelled',
    ticketActivationErrorAlt: 'Error activating ticket',
    ticketActivationSuccess: '🎉 Ticket activated successfully! Your trial will last 7 days.',
    feedbackSaveError: 'Error saving feedback',
    roomCreationErrorAlt: 'Error creating room',
    trialCleanupError: 'Error cleaning up trial users',
    internalServerError: 'Internal server error',

    // Translation Panel
    translationTitle: 'Translation',
    translationFast: 'Fast',
    translationQuality: 'Quality',
    translationISpeak: 'I speak',
    translationSwitching: 'Switching...',
    translationTranslateTo: 'Translate to',
    translationStart: 'Start Translation',
    translationStop: 'Stop Translation',
    translationActivateTitle: 'Enable translation',
    translationActivateSubtitle: 'Pick your language and your guest\u2019s language, then press Start to begin the real-time translated conversation.',
    translationPromptSpeaks: 'speaks',
    translationPromptYouSpeak: 'You speak',
    translationPromptActivate: 'Enable translation',
    translationPromptDismiss: 'Not now',
    translationClonedVoiceActive: 'Your cloned voice will be used.',
    translationNoClonedVoice: 'No cloned voice — a default voice will be used.',
    translationReRecord: 'Re-record',
    translationRecordVoice: 'Record voice',
    translationActiveFast: 'Translating via SeamlessM4T (server-side, low latency).',
    translationActiveQuality: 'Translating via Deepgram + Cartesia with your cloned voice.',
    translationStsOffline: 'STS engine offline. Using browser-side translation (higher latency).',

    // Control Bar Tooltips
    tooltipMuteMic: 'Mute microphone',
    tooltipUnmuteMic: 'Unmute microphone',
    tooltipSwitchMic: 'Switch microphone',
    tooltipCameraOff: 'Turn off camera',
    tooltipCameraOn: 'Turn on camera',
    tooltipSwitchCamera: 'Switch camera',
    tooltipShareScreen: 'Share screen',
    tooltipStopSharing: 'Stop sharing',
    tooltipTranslation: 'Translation',
    tooltipCloseTranslation: 'Close translation',
    tooltipLeaveRoom: 'Leave room',
    tooltipChat: 'Chat',
    tooltipCloseChat: 'Close chat',
    tooltipCopied: 'Copied!',
    tooltipInvite: 'Invite someone',
    tooltipSubtitlesOn: 'Hide subtitles',
    tooltipSubtitlesOff: 'Subtitles',
    chatNoMessages: 'No messages yet',
    chatPlaceholder: 'Type a message...',
  },

  es: {
    // Common
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    back: 'Atrás',
    next: 'Siguiente',
    confirm: 'Confirmar',
    error: 'Error',
    success: 'Éxito',

    // Navigation
    dashboard: 'Panel',
    profile: 'Perfil',
    settings: 'Configuración',
    logout: 'Cerrar sesión',

    // Dashboard
    welcomeBack: 'Bienvenido de nuevo',
    there: 'hola',
    manageRooms: 'Gestiona tus salas y comienza a colaborar',
    yourRooms: 'Tus salas',
    createRoom: 'Crear Sala',
    joinRoom: 'Unirse',
    noRooms: 'No hay salas disponibles',
    noRoomsFound: 'No se encontraron salas',
    tryAdjusting: 'Intenta ajustar tu búsqueda.',
    createToStart: 'Crea una sala para comenzar.',
    roomsDescription: 'Crea o únete a salas de videoconferencia con traducción en tiempo real',
    quickStart: 'Inicio Rápido',
    instantMeeting: 'Reunión instantánea',
    newRoom: 'Nueva Sala',
    scheduleForLater: 'Programar para después',
    quickInvite: 'Invitación Rápida',
    startCallNow: 'Iniciar llamada ahora',
    scheduleCall: 'Programar Llamada',
    planForLater: 'Planificar para después',
    search: 'Buscar...',
    public: 'Pública',
    private: 'Privada',
    deleteRoom: 'Eliminar sala',
    confirmDelete: '¿Estás seguro de que quieres eliminar',
    roomDeleted: 'Sala eliminada',
    failedToDelete: 'No se pudo eliminar la sala',
    roomCreated: '¡Sala creada con éxito!',
    failedToCreate: 'No se pudo crear la sala',
    roomNameLabel: 'Nombre',
    roomNamePlaceholder: 'Sincronización Semanal',
    descriptionLabel: 'Descripción',
    descriptionPlaceholder: 'Opcional...',
    publicRoomLabel: 'Sala Pública',
    create: 'Crear',
    inviteGuest: 'Invitar Invitado',
    joinCall: 'Unirse a la Llamada',
    copy: 'Copiar',
    share: 'Compartir',
    admin: 'Admin',
    user: 'Usuario',

    // Profile
    profileTitle: 'Tu perfil',
    profileDescription: 'Gestiona tu información personal y preferencias',
    backToDashboard: 'Volver al Panel',
    profileInfo: 'Información del Perfil',
    updatePhotoInfo: 'Actualiza tu foto e información personal',
    fullName: 'Nombre completo',
    email: 'Correo electrónico',
    emailManaged: 'El correo es gestionado por Clerk y no se puede modificar aquí',
    preferredLanguage: 'Idioma preferido',
    changePhoto: 'Cambiar foto',
    saveChanges: 'Guardar cambios',
    saving: 'Guardando...',
    profileUpdated: '¡Perfil actualizado con éxito!',
    profileUpdateError: 'Error al actualizar el perfil',

    // Referral
    referralCode: 'Código de Referido',
    inviteFriends: 'Invita amigos y gana créditos de bonificación',
    shareLink: 'Comparte tu enlace de referido y recibe',
    creditsPerFriend: '50 créditos',
    perFriend: '¡por cada amigo que se registre!',
    friendsInvited: 'Amigos Invitados',
    creditsEarned: 'Créditos Ganados',
    yourReferrals: 'Tus Referencias',
    friendsJoinedWithLink: 'Amigos que se unieron con tu enlace',
    referrals: 'Referencias',
    copied: 'Copiado',
    accountDetails: 'Detalles de la Cuenta',

    // Danger Zone
    dangerZone: 'Zona Peligrosa',
    permanentAction: 'Acciones permanentes que no se pueden deshacer',
    deleteAccount: 'Eliminar Cuenta',
    deleteAccountWarning: 'Eliminar permanentemente tu cuenta, datos y todo el contenido asociado',
    confirmDeleteAccount: 'Confirmar Eliminación de Cuenta',
    deleteWarningTitle: '¡Esta acción es permanente y no se puede deshacer!',
    deleteWarningText: 'Eliminar tu cuenta:',
    deleteWarning1: 'Eliminará permanentemente todos tus datos',
    deleteWarning2: 'Eliminará todas tus salas y grabaciones',
    deleteWarning3: 'Eliminará tus clones de voz',
    deleteWarning4: 'Cancelará tu suscripción (si está activa)',
    typeDeleteConfirm: 'Escribe',
    toConfirm: 'para confirmar',
    deleting: 'Eliminando...',
    deleteAccountPermanent: 'Eliminar Cuenta Permanentemente',
    typeDeleteToConfirm: 'Escribe DELETE para confirmar',
    accountDeleted: 'Cuenta eliminada con éxito',

    // Account Stats
    accountStats: 'Estadísticas de Cuenta',
    availableCredits: 'Créditos disponibles',
    trialExpires: 'Prueba expira el',
    plan: 'Plan',
    status: 'Estado',
    referralCodeLabel: 'Código de referencia',

    // Trial System
    trialSession: 'Sesión de Prueba',
    trialActive: 'Prueba Activa',
    trialExpired: 'Prueba Expirada',
    daysRemaining: 'días restantes',
    activateTrial: 'Activar Prueba',
    enterTrialCode: 'Ingresa código de prueba',
    activateCode: 'Activar Código',
    trialCodePlaceholder: 'TRIAL-XXXXXXXX',
    activating: 'Activando...',
    trialActivated: '¡Prueba activada con éxito!',
    invalidTrialCode: 'Código de prueba no válido',
    trialCodeExpired: 'Código de prueba expirado',
    trialCodeAlreadyUsed: 'Código de prueba ya utilizado',
    trialEndsOn: 'Termina el',
    upgradeNow: 'Actualizar a Premium',
    trialExpiredTitle: 'Tu período de prueba ha terminado',
    trialExpiredDescription: 'Tus 7 días de acceso gratuito han expirado.',

    // Auth
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    signOut: 'Cerrar sesión',
    signedOut: 'Sesión cerrada con éxito',
    signOutError: 'Error al cerrar sesión',

    // Room
    roomName: 'Nombre de la sala',
    participants: 'Participantes',
    duration: 'Duración',
    active: 'Activa',
    inactive: 'Inactiva',

    // Credits
    credits: 'Créditos',
    buyCredits: 'Comprar Créditos',
    freeCredits: 'Créditos gratuitos',

    // Languages
    italian: 'Italiano',
    english: 'Inglés',
    spanish: 'Español',
    french: 'Francés',
    german: 'Alemán',

    // Admin
    metricsRefreshed: 'Métricas actualizadas',
    autoOn: 'Auto ON',
    autoOff: 'Auto OFF',
    unnamedRoom: 'Sala sin nombre',
    unknownError: 'Error desconocido',

    // Trial Limit Modal
    featureNotAvailable: 'Función No Disponible',
    trialProfileLimit: 'La configuración del perfil no está disponible para usuarios de prueba. ¡Regístrate para acceder a todas las funciones!',
    withFullAccount: 'Con una cuenta completa obtienes:',
    customProfile: 'Perfil personalizado',
    savedRoomsPermanently: 'Salas guardadas permanentemente',
    unlimitedAccess: 'Acceso ilimitado',
    prioritySupport: 'Soporte prioritario',
    continueTrial: 'Continuar Prueba',
    signUpNow: 'Regístrate Ahora',

    // Toast Messages
    welcomeBackSuccess: '¡Bienvenido de nuevo! Inicio de sesión exitoso',
    welcomeTrialStarted: '¡Bienvenido! Tu prueba ha comenzado',
    errorActivation: 'Error durante la activación',
    connectionError: 'Error de conexión',
    imageUploadError: 'Error al cargar la imagen',
    roomCreationError: 'Error al crear la sala',
    trialRoomCreationError: 'Error al crear la sala de prueba',
    sendingCalendarInvite: 'Enviando invitación de calendario...',
    recordingStarted: 'Grabación iniciada',
    recordingStartError: 'Error al iniciar la grabación',
    playbackError: 'Error de reproducción',
    recordingDeleted: 'Grabación eliminada',
    ticketsGenerated: 'tickets generados con éxito',
    ticketsGenerationError: 'No se pueden generar tickets',
    codeCopied: 'Código copiado al portapapeles',
    ticketDeleted: 'Ticket eliminado con éxito',
    ticketDeletionError: 'No se puede eliminar el ticket',
    voiceSavedSuccess: '✅ ¡Voz guardada con éxito! Esta es ahora tu voz activa.',
    profileUpdateErrorAlt: 'Error al actualizar el perfil',

    // UI Labels & Buttons
    schedule: 'Programar',
    calendarInviteDescription: 'Generaremos un enlace de invitación de calendario que puedes compartir',
    confirmAndContinue: 'Confirmar y Continuar',
    loadingAdminDashboard: 'Cargando panel de administración...',
    loadingGeneric: 'Cargando...',

    // Admin Trial Tickets
    ticketsCancelled: '✕ Cancelado',
    completedRegistrations: 'Usuarios que completaron el registro con ticket de prueba (guardados para contacto futuro)',
    confirmTicketDeletion: '¿Estás seguro de que quieres eliminar este ticket?',
    ticketDeletionWarning: 'Esta acción no se puede deshacer. El ticket se eliminará permanentemente de la base de datos.',

    // Trial Expired Page
    accountBeingDeleted: 'Cuenta siendo eliminada',
    accountDeletionWarning: 'Tu cuenta de prueba será eliminada automáticamente. Todos los datos asociados serán eliminados permanentemente.',

    // Room Errors
    roomConnectionError: 'Ocurrió un error al conectarse a la sala.',
    ticketActivationError: 'Error al activar el ticket',
    sessionVerificationError: 'Error al verificar la sesión',

    // API Error Messages
    validationError: 'Error de validación',
    serverError: 'Error del servidor',
    sessionValidationError: 'Error de validación de sesión',
    internalError: 'Error interno',
    trialSessionExpired: 'Sesión de prueba expirada o cancelada',
    ticketActivationErrorAlt: 'Error al activar el ticket',
    ticketActivationSuccess: '🎉 ¡Ticket activado con éxito! Tu prueba durará 7 días.',
    feedbackSaveError: 'Error al guardar comentarios',
    roomCreationErrorAlt: 'Error al crear la sala',
    trialCleanupError: 'Error al limpiar usuarios de prueba',
    internalServerError: 'Error interno del servidor',

    // Translation Panel
    translationTitle: 'Traducción',
    translationFast: 'Rápida',
    translationQuality: 'Calidad',
    translationISpeak: 'Hablo',
    translationSwitching: 'Cambiando...',
    translationTranslateTo: 'Traducir a',
    translationStart: 'Iniciar Traducción',
    translationStop: 'Detener Traducción',
    translationActivateTitle: 'Activar la traducción',
    translationActivateSubtitle: 'Elige tu idioma y el de tu invitado, luego pulsa Iniciar para comenzar la conversación traducida en tiempo real.',
    translationPromptSpeaks: 'habla',
    translationPromptYouSpeak: 'Tú hablas',
    translationPromptActivate: 'Activar la traducción',
    translationPromptDismiss: 'Ahora no',
    translationClonedVoiceActive: 'Se usará tu voz clonada.',
    translationNoClonedVoice: 'Sin voz clonada — se usará una voz predeterminada.',
    translationReRecord: 'Grabar de nuevo',
    translationRecordVoice: 'Grabar voz',
    translationActiveFast: 'Traduciendo con SeamlessM4T (servidor, baja latencia).',
    translationActiveQuality: 'Traduciendo con Deepgram + Cartesia con tu voz clonada.',
    translationStsOffline: 'Motor STS sin conexión. Traducción en el navegador (mayor latencia).',

    // Control Bar Tooltips
    tooltipMuteMic: 'Silenciar micrófono',
    tooltipUnmuteMic: 'Activar micrófono',
    tooltipSwitchMic: 'Cambiar micrófono',
    tooltipCameraOff: 'Desactivar cámara',
    tooltipCameraOn: 'Activar cámara',
    tooltipSwitchCamera: 'Cambiar cámara',
    tooltipShareScreen: 'Compartir pantalla',
    tooltipStopSharing: 'Dejar de compartir',
    tooltipTranslation: 'Traducción',
    tooltipCloseTranslation: 'Cerrar traducción',
    tooltipLeaveRoom: 'Salir de la sala',
    tooltipChat: 'Chat',
    tooltipCloseChat: 'Cerrar chat',
    tooltipCopied: '¡Copiado!',
    tooltipInvite: 'Invitar a alguien',
    tooltipSubtitlesOn: 'Ocultar subtítulos',
    tooltipSubtitlesOff: 'Subtítulos',
    chatNoMessages: 'Sin mensajes',
    chatPlaceholder: 'Escribe un mensaje...',
  },

  fr: {
    // Common
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    confirm: 'Confirmer',
    error: 'Erreur',
    success: 'Succès',

    // Navigation
    dashboard: 'Tableau de bord',
    profile: 'Profil',
    settings: 'Paramètres',
    logout: 'Déconnexion',

    // Dashboard
    welcomeBack: 'Bon retour',
    there: 'bonjour',
    manageRooms: 'Gérez vos salles et commencez à collaborer',
    yourRooms: 'Vos salles',
    createRoom: 'Créer une Salle',
    joinRoom: 'Rejoindre',
    noRooms: 'Aucune salle disponible',
    noRoomsFound: 'Aucune salle trouvée',
    tryAdjusting: 'Essayez d\'ajuster votre recherche.',
    createToStart: 'Créez une salle pour commencer.',
    roomsDescription: 'Créez ou rejoignez des salles de visioconférence avec traduction en temps réel',
    quickStart: 'Démarrage Rapide',
    instantMeeting: 'Réunion instantanée',
    newRoom: 'Nouvelle Salle',
    scheduleForLater: 'Planifier pour plus tard',
    quickInvite: 'Invitation Rapide',
    startCallNow: 'Démarrer l\'appel maintenant',
    scheduleCall: 'Planifier un Appel',
    planForLater: 'Planifier pour plus tard',
    search: 'Rechercher...',
    public: 'Publique',
    private: 'Privée',
    deleteRoom: 'Supprimer la salle',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer',
    roomDeleted: 'Salle supprimée',
    failedToDelete: 'Échec de la suppression de la salle',
    roomCreated: 'Salle créée avec succès !',
    failedToCreate: 'Échec de la création de la salle',
    roomNameLabel: 'Nom',
    roomNamePlaceholder: 'Synchronisation Hebdomadaire',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Facultatif...',
    publicRoomLabel: 'Salle Publique',
    create: 'Créer',
    inviteGuest: 'Inviter un Invité',
    joinCall: 'Rejoindre l\'Appel',
    copy: 'Copier',
    share: 'Partager',
    admin: 'Admin',
    user: 'Utilisateur',

    // Profile
    profileTitle: 'Votre profil',
    profileDescription: 'Gérez vos informations personnelles et préférences',
    backToDashboard: 'Retour au Tableau de bord',
    profileInfo: 'Informations du Profil',
    updatePhotoInfo: 'Mettez à jour votre photo et vos informations personnelles',
    fullName: 'Nom complet',
    email: 'Email',
    emailManaged: "L'email est géré par Clerk et ne peut pas être modifié ici",
    preferredLanguage: 'Langue préférée',
    changePhoto: 'Changer la photo',
    saveChanges: 'Enregistrer les modifications',
    saving: 'Enregistrement...',
    profileUpdated: 'Profil mis à jour avec succès !',
    profileUpdateError: 'Erreur lors de la mise à jour du profil',

    // Referral
    referralCode: 'Code de Parrainage',
    inviteFriends: 'Invitez des amis et gagnez des crédits bonus',
    shareLink: 'Partagez votre lien de parrainage et recevez',
    creditsPerFriend: '50 crédits',
    perFriend: 'pour chaque ami qui s\'inscrit !',
    friendsInvited: 'Amis Invités',
    creditsEarned: 'Crédits Gagnés',
    yourReferrals: 'Vos Parrainages',
    friendsJoinedWithLink: 'Amis qui se sont inscrits avec votre lien',
    referrals: 'Parrainages',
    copied: 'Copié',
    accountDetails: 'Détails du Compte',

    // Danger Zone
    dangerZone: 'Zone Dangereuse',
    permanentAction: 'Actions permanentes qui ne peuvent pas être annulées',
    deleteAccount: 'Supprimer le Compte',
    deleteAccountWarning: 'Supprimer définitivement votre compte, vos données et tout le contenu associé',
    confirmDeleteAccount: 'Confirmer la Suppression du Compte',
    deleteWarningTitle: 'Cette action est permanente et ne peut pas être annulée !',
    deleteWarningText: 'La suppression de votre compte :',
    deleteWarning1: 'Supprimera définitivement toutes vos données',
    deleteWarning2: 'Supprimera toutes vos salles et enregistrements',
    deleteWarning3: 'Supprimera vos clones vocaux',
    deleteWarning4: 'Annulera votre abonnement (si actif)',
    typeDeleteConfirm: 'Tapez',
    toConfirm: 'pour confirmer',
    deleting: 'Suppression...',
    deleteAccountPermanent: 'Supprimer le Compte Définitivement',
    typeDeleteToConfirm: 'Tapez DELETE pour confirmer',
    accountDeleted: 'Compte supprimé avec succès',

    // Account Stats
    accountStats: 'Statistiques du Compte',
    availableCredits: 'Crédits disponibles',
    trialExpires: 'Essai expire le',
    plan: 'Plan',
    status: 'Statut',
    referralCodeLabel: 'Code de parrainage',

    // Trial System
    trialSession: 'Session d\'Essai',
    trialActive: 'Essai Actif',
    trialExpired: 'Essai Expiré',
    daysRemaining: 'jours restants',
    activateTrial: 'Activer l\'Essai',
    enterTrialCode: 'Entrez le code d\'essai',
    activateCode: 'Activer le Code',
    trialCodePlaceholder: 'TRIAL-XXXXXXXX',
    activating: 'Activation...',
    trialActivated: 'Essai activé avec succès !',
    invalidTrialCode: 'Code d\'essai non valide',
    trialCodeExpired: 'Code d\'essai expiré',
    trialCodeAlreadyUsed: 'Code d\'essai déjà utilisé',
    trialEndsOn: 'Se termine le',
    upgradeNow: 'Passer à Premium',
    trialExpiredTitle: 'Votre période d\'essai est terminée',
    trialExpiredDescription: 'Vos 7 jours d\'accès gratuit ont expiré.',

    // Auth
    signIn: 'Se connecter',
    signUp: 'S\'inscrire',
    signOut: 'Se déconnecter',
    signedOut: 'Déconnexion réussie',
    signOutError: 'Erreur lors de la déconnexion',

    // Room
    roomName: 'Nom de la salle',
    participants: 'Participants',
    duration: 'Durée',

    active: 'Active',
    inactive: 'Inactive',

    // Credits
    credits: 'Crédits',
    buyCredits: 'Acheter des Crédits',
    freeCredits: 'Crédits gratuits',

    // Languages
    italian: 'Italien',
    english: 'Anglais',
    spanish: 'Espagnol',
    french: 'Français',
    german: 'Allemand',

    // Admin
    metricsRefreshed: 'Métriques actualisées',
    autoOn: 'Auto ON',
    autoOff: 'Auto OFF',
    unnamedRoom: 'Salle sans nom',
    unknownError: 'Erreur inconnue',

    // Trial Limit Modal
    featureNotAvailable: 'Fonctionnalité Non Disponible',
    trialProfileLimit: 'Les paramètres de profil ne sont pas disponibles pour les utilisateurs d\'essai. Inscrivez-vous pour accéder à toutes les fonctionnalités !',
    withFullAccount: 'Avec un compte complet, vous obtenez :',
    customProfile: 'Profil personnalisé',
    savedRoomsPermanently: 'Salles enregistrées en permanence',
    unlimitedAccess: 'Accès illimité',
    prioritySupport: 'Support prioritaire',
    continueTrial: 'Continuer l\'Essai',
    signUpNow: 'S\'Inscrire Maintenant',

    // Toast Messages
    welcomeBackSuccess: 'Bienvenue ! Connexion réussie',
    welcomeTrialStarted: 'Bienvenue ! Votre essai a commencé',
    errorActivation: 'Erreur lors de l\'activation',
    connectionError: 'Erreur de connexion',
    imageUploadError: 'Erreur lors du téléchargement de l\'image',
    roomCreationError: 'Erreur lors de la création de la salle',
    trialRoomCreationError: 'Erreur lors de la création de la salle d\'essai',
    sendingCalendarInvite: 'Envoi de l\'invitation au calendrier...',
    recordingStarted: 'Enregistrement démarré',
    recordingStartError: 'Erreur lors du démarrage de l\'enregistrement',
    playbackError: 'Erreur de lecture',
    recordingDeleted: 'Enregistrement supprimé',
    ticketsGenerated: 'tickets générés avec succès',
    ticketsGenerationError: 'Impossible de générer les tickets',
    codeCopied: 'Code copié dans le presse-papiers',
    ticketDeleted: 'Ticket supprimé avec succès',
    ticketDeletionError: 'Impossible de supprimer le ticket',
    voiceSavedSuccess: '✅ Voix enregistrée avec succès ! C\'est maintenant votre voix active.',
    profileUpdateErrorAlt: 'Erreur lors de la mise à jour du profil',

    // UI Labels & Buttons
    schedule: 'Planifier',
    calendarInviteDescription: 'Nous générerons un lien d\'invitation au calendrier que vous pourrez partager',
    confirmAndContinue: 'Confirmer et Continuer',
    loadingAdminDashboard: 'Chargement du tableau de bord admin...',
    loadingGeneric: 'Chargement...',

    // Admin Trial Tickets
    ticketsCancelled: '✕ Annulé',
    completedRegistrations: 'Utilisateurs ayant terminé l\'inscription avec un ticket d\'essai (enregistrés pour un contact futur)',
    confirmTicketDeletion: 'Êtes-vous sûr de vouloir supprimer ce ticket ?',
    ticketDeletionWarning: 'Cette action ne peut pas être annulée. Le ticket sera définitivement supprimé de la base de données.',

    // Trial Expired Page
    accountBeingDeleted: 'Compte en cours de suppression',
    accountDeletionWarning: 'Votre compte d\'essai sera automatiquement supprimé. Toutes les données associées seront définitivement supprimées.',

    // Room Errors
    roomConnectionError: 'Une erreur s\'est produite lors de la connexion à la salle.',
    ticketActivationError: 'Erreur lors de l\'activation du ticket',
    sessionVerificationError: 'Erreur lors de la vérification de la session',

    // API Error Messages
    validationError: 'Erreur de validation',
    serverError: 'Erreur du serveur',
    sessionValidationError: 'Erreur de validation de session',
    internalError: 'Erreur interne',
    trialSessionExpired: 'Session d\'essai expirée ou annulée',
    ticketActivationErrorAlt: 'Erreur lors de l\'activation du ticket',
    ticketActivationSuccess: '🎉 Ticket activé avec succès ! Votre essai durera 7 jours.',
    feedbackSaveError: 'Erreur lors de l\'enregistrement des commentaires',
    roomCreationErrorAlt: 'Erreur lors de la création de la salle',
    trialCleanupError: 'Erreur lors du nettoyage des utilisateurs d\'essai',
    internalServerError: 'Erreur interne du serveur',

    // Translation Panel
    translationTitle: 'Traduction',
    translationFast: 'Rapide',
    translationQuality: 'Qualité',
    translationISpeak: 'Je parle',
    translationSwitching: 'Changement...',
    translationTranslateTo: 'Traduire en',
    translationStart: 'Démarrer la traduction',
    translationStop: 'Arrêter la traduction',
    translationActivateTitle: 'Activer la traduction',
    translationActivateSubtitle: 'Choisissez votre langue et celle de votre invité, puis appuyez sur Démarrer pour lancer la conversation traduite en temps réel.',
    translationPromptSpeaks: 'parle',
    translationPromptYouSpeak: 'Vous parlez',
    translationPromptActivate: 'Activer la traduction',
    translationPromptDismiss: 'Plus tard',
    translationClonedVoiceActive: 'Votre voix clonée sera utilisée.',
    translationNoClonedVoice: 'Pas de voix clonée — une voix par défaut sera utilisée.',
    translationReRecord: 'Réenregistrer',
    translationRecordVoice: 'Enregistrer la voix',
    translationActiveFast: 'Traduction via SeamlessM4T (serveur, faible latence).',
    translationActiveQuality: 'Traduction via Deepgram + Cartesia avec votre voix clonée.',
    translationStsOffline: 'Moteur STS hors ligne. Traduction côté navigateur (latence plus élevée).',

    // Control Bar Tooltips
    tooltipMuteMic: 'Désactiver le micro',
    tooltipUnmuteMic: 'Activer le micro',
    tooltipSwitchMic: 'Changer de micro',
    tooltipCameraOff: 'Désactiver la caméra',
    tooltipCameraOn: 'Activer la caméra',
    tooltipSwitchCamera: 'Changer de caméra',
    tooltipShareScreen: 'Partager l\'écran',
    tooltipStopSharing: 'Arrêter le partage',
    tooltipTranslation: 'Traduction',
    tooltipCloseTranslation: 'Fermer la traduction',
    tooltipLeaveRoom: 'Quitter la salle',
    tooltipChat: 'Chat',
    tooltipCloseChat: 'Fermer le chat',
    tooltipCopied: 'Copié !',
    tooltipInvite: 'Inviter quelqu\'un',
    tooltipSubtitlesOn: 'Masquer les sous-titres',
    tooltipSubtitlesOff: 'Sous-titres',
    chatNoMessages: 'Aucun message',
    chatPlaceholder: 'Tapez un message...',
  },

  de: {
    // Common
    loading: 'Laden...',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    close: 'Schließen',
    back: 'Zurück',
    next: 'Weiter',
    confirm: 'Bestätigen',
    error: 'Fehler',
    success: 'Erfolg',

    // Navigation
    dashboard: 'Dashboard',
    profile: 'Profil',
    settings: 'Einstellungen',
    logout: 'Abmelden',

    // Dashboard
    welcomeBack: 'Willkommen zurück',
    there: 'hallo',
    manageRooms: 'Verwalten Sie Ihre Räume und beginnen Sie mit der Zusammenarbeit',
    yourRooms: 'Ihre Räume',
    createRoom: 'Raum erstellen',
    joinRoom: 'Beitreten',
    noRooms: 'Keine Räume verfügbar',
    noRoomsFound: 'Keine Räume gefunden',
    tryAdjusting: 'Versuchen Sie, Ihre Suche anzupassen.',
    createToStart: 'Erstellen Sie einen Raum, um zu beginnen.',
    roomsDescription: 'Erstellen oder treten Sie Videokonferenzräumen mit Echtzeit-Übersetzung bei',
    quickStart: 'Schnellstart',
    instantMeeting: 'Sofortbesprechung',
    newRoom: 'Neuer Raum',
    scheduleForLater: 'Für später planen',
    quickInvite: 'Schnelleinladung',
    startCallNow: 'Anruf jetzt starten',
    scheduleCall: 'Anruf planen',
    planForLater: 'Für später planen',
    search: 'Suchen...',
    public: 'Öffentlich',
    private: 'Privat',
    deleteRoom: 'Raum löschen',
    confirmDelete: 'Sind Sie sicher, dass Sie löschen möchten',
    roomDeleted: 'Raum gelöscht',
    failedToDelete: 'Raum konnte nicht gelöscht werden',
    roomCreated: 'Raum erfolgreich erstellt!',
    failedToCreate: 'Raum konnte nicht erstellt werden',
    roomNameLabel: 'Name',
    roomNamePlaceholder: 'Wöchentliche Synchronisierung',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Optional...',
    publicRoomLabel: 'Öffentlicher Raum',
    create: 'Erstellen',
    inviteGuest: 'Gast einladen',
    joinCall: 'Anruf beitreten',
    copy: 'Kopieren',
    share: 'Teilen',
    admin: 'Admin',
    user: 'Benutzer',

    // Profile
    profileTitle: 'Ihr Profil',
    profileDescription: 'Verwalten Sie Ihre persönlichen Informationen und Einstellungen',
    backToDashboard: 'Zurück zum Dashboard',
    profileInfo: 'Profilinformationen',
    updatePhotoInfo: 'Aktualisieren Sie Ihr Foto und Ihre persönlichen Informationen',
    fullName: 'Vollständiger Name',
    email: 'E-Mail',
    emailManaged: 'Die E-Mail wird von Clerk verwaltet und kann hier nicht geändert werden',
    preferredLanguage: 'Bevorzugte Sprache',
    changePhoto: 'Foto ändern',
    saveChanges: 'Änderungen speichern',
    saving: 'Speichern...',
    profileUpdated: 'Profil erfolgreich aktualisiert!',
    profileUpdateError: 'Fehler beim Aktualisieren des Profils',

    // Referral
    referralCode: 'Empfehlungscode',
    inviteFriends: 'Laden Sie Freunde ein und verdienen Sie Bonuspunkte',
    shareLink: 'Teilen Sie Ihren Empfehlungslink und erhalten Sie',
    creditsPerFriend: '50 Credits',
    perFriend: 'für jeden Freund, der sich anmeldet!',
    friendsInvited: 'Eingeladene Freunde',
    creditsEarned: 'Verdiente Credits',
    yourReferrals: 'Ihre Empfehlungen',
    friendsJoinedWithLink: 'Freunde, die sich mit Ihrem Link angemeldet haben',
    referrals: 'Empfehlungen',
    copied: 'Kopiert',
    accountDetails: 'Kontodetails',

    // Danger Zone
    dangerZone: 'Gefahrenzone',
    permanentAction: 'Permanente Aktionen, die nicht rückgängig gemacht werden können',
    deleteAccount: 'Konto Löschen',
    deleteAccountWarning: 'Löschen Sie dauerhaft Ihr Konto, Ihre Daten und alle zugehörigen Inhalte',
    confirmDeleteAccount: 'Kontolöschung Bestätigen',
    deleteWarningTitle: 'Diese Aktion ist permanent und kann nicht rückgängig gemacht werden!',
    deleteWarningText: 'Das Löschen Ihres Kontos wird:',
    deleteWarning1: 'Alle Ihre Daten dauerhaft löschen',
    deleteWarning2: 'Alle Ihre Räume und Aufnahmen entfernen',
    deleteWarning3: 'Ihre Stimmklone löschen',
    deleteWarning4: 'Ihr Abonnement kündigen (falls aktiv)',
    typeDeleteConfirm: 'Geben Sie',
    toConfirm: 'ein, um zu bestätigen',
    deleting: 'Löschen...',
    deleteAccountPermanent: 'Konto Dauerhaft Löschen',
    typeDeleteToConfirm: 'Geben Sie DELETE ein, um zu bestätigen',
    accountDeleted: 'Konto erfolgreich gelöscht',

    // Account Stats
    accountStats: 'Kontostatistiken',
    availableCredits: 'Verfügbare Credits',
    trialExpires: 'Testversion läuft ab am',
    plan: 'Plan',
    status: 'Status',
    referralCodeLabel: 'Empfehlungscode',

    // Trial System
    trialSession: 'Testsitzung',
    trialActive: 'Test Aktiv',
    trialExpired: 'Test Abgelaufen',
    daysRemaining: 'Tage verbleibend',
    activateTrial: 'Test Aktivieren',
    enterTrialCode: 'Testcode eingeben',
    activateCode: 'Code Aktivieren',
    trialCodePlaceholder: 'TRIAL-XXXXXXXX',
    activating: 'Aktivierung...',
    trialActivated: 'Test erfolgreich aktiviert!',
    invalidTrialCode: 'Ungültiger Testcode',
    trialCodeExpired: 'Testcode abgelaufen',
    trialCodeAlreadyUsed: 'Testcode bereits verwendet',
    trialEndsOn: 'Endet am',
    upgradeNow: 'Auf Premium upgraden',
    trialExpiredTitle: 'Ihre Testphase ist beendet',
    trialExpiredDescription: 'Ihre 7-tägige kostenlose Testphase ist abgelaufen.',

    // Auth
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    signOut: 'Abmelden',
    signedOut: 'Erfolgreich abgemeldet',
    signOutError: 'Fehler beim Abmelden',

    // Room
    roomName: 'Raumname',
    participants: 'Teilnehmer',
    duration: 'Dauer',
    active: 'Aktiv',
    inactive: 'Inaktiv',

    // Credits
    credits: 'Credits',
    buyCredits: 'Credits kaufen',
    freeCredits: 'Kostenlose Credits',

    // Languages
    italian: 'Italienisch',
    english: 'Englisch',
    spanish: 'Spanisch',
    french: 'Französisch',
    german: 'Deutsch',

    // Admin
    metricsRefreshed: 'Metriken aktualisiert',
    autoOn: 'Auto EIN',
    autoOff: 'Auto AUS',
    unnamedRoom: 'Raum ohne Namen',
    unknownError: 'Unbekannter Fehler',

    // Trial Limit Modal
    featureNotAvailable: 'Funktion Nicht Verfügbar',
    trialProfileLimit: 'Profileinstellungen sind für Testbenutzer nicht verfügbar. Registrieren Sie sich, um auf alle Funktionen zuzugreifen!',
    withFullAccount: 'Mit einem vollständigen Konto erhalten Sie:',
    customProfile: 'Benutzerdefiniertes Profil',
    savedRoomsPermanently: 'Dauerhaft gespeicherte Räume',
    unlimitedAccess: 'Unbegrenzter Zugang',
    prioritySupport: 'Prioritäts-Support',
    continueTrial: 'Test Fortsetzen',
    signUpNow: 'Jetzt Registrieren',

    // Toast Messages
    welcomeBackSuccess: 'Willkommen zurück! Erfolgreich angemeldet',
    welcomeTrialStarted: 'Willkommen! Ihr Test hat begonnen',
    errorActivation: 'Fehler bei der Aktivierung',
    connectionError: 'Verbindungsfehler',
    imageUploadError: 'Fehler beim Hochladen des Bildes',
    roomCreationError: 'Fehler beim Erstellen des Raums',
    trialRoomCreationError: 'Fehler beim Erstellen des Test-Raums',
    sendingCalendarInvite: 'Kalendereinladung wird gesendet...',
    recordingStarted: 'Aufnahme gestartet',
    recordingStartError: 'Fehler beim Starten der Aufnahme',
    playbackError: 'Wiedergabefehler',
    recordingDeleted: 'Aufnahme gelöscht',
    ticketsGenerated: 'Tickets erfolgreich generiert',
    ticketsGenerationError: 'Tickets können nicht generiert werden',
    codeCopied: 'Code in die Zwischenablage kopiert',
    ticketDeleted: 'Ticket erfolgreich gelöscht',
    ticketDeletionError: 'Ticket kann nicht gelöscht werden',
    voiceSavedSuccess: '✅ Stimme erfolgreich gespeichert! Dies ist jetzt Ihre aktive Stimme.',
    profileUpdateErrorAlt: 'Fehler beim Aktualisieren des Profils',

    // UI Labels & Buttons
    schedule: 'Planen',
    calendarInviteDescription: 'Wir erstellen einen Kalendereinladungslink, den Sie teilen können',
    confirmAndContinue: 'Bestätigen und Fortfahren',
    loadingAdminDashboard: 'Admin-Dashboard wird geladen...',
    loadingGeneric: 'Wird geladen...',

    // Admin Trial Tickets
    ticketsCancelled: '✕ Storniert',
    completedRegistrations: 'Benutzer, die sich mit Test-Ticket registriert haben (für zukünftigen Kontakt gespeichert)',
    confirmTicketDeletion: 'Sind Sie sicher, dass Sie dieses Ticket löschen möchten?',
    ticketDeletionWarning: 'Diese Aktion kann nicht rückgängig gemacht werden. Das Ticket wird dauerhaft aus der Datenbank gelöscht.',

    // Trial Expired Page
    accountBeingDeleted: 'Konto wird gelöscht',
    accountDeletionWarning: 'Ihr Testkonto wird automatisch gelöscht. Alle zugehörigen Daten werden dauerhaft entfernt.',

    // Room Errors
    roomConnectionError: 'Beim Verbinden mit dem Raum ist ein Fehler aufgetreten.',
    ticketActivationError: 'Fehler beim Aktivieren des Tickets',
    sessionVerificationError: 'Fehler beim Verifizieren der Sitzung',

    // API Error Messages
    validationError: 'Validierungsfehler',
    serverError: 'Serverfehler',
    sessionValidationError: 'Sitzungsvalidierungsfehler',
    internalError: 'Interner Fehler',
    trialSessionExpired: 'Testsitzung abgelaufen oder storniert',
    ticketActivationErrorAlt: 'Fehler beim Aktivieren des Tickets',
    ticketActivationSuccess: '🎉 Ticket erfolgreich aktiviert! Ihr Test dauert 7 Tage.',
    feedbackSaveError: 'Fehler beim Speichern des Feedbacks',
    roomCreationErrorAlt: 'Fehler beim Erstellen des Raums',
    trialCleanupError: 'Fehler beim Bereinigen der Testbenutzer',
    internalServerError: 'Interner Serverfehler',

    // Translation Panel
    translationTitle: 'Übersetzung',
    translationFast: 'Schnell',
    translationQuality: 'Qualität',
    translationISpeak: 'Ich spreche',
    translationSwitching: 'Wechsel...',
    translationTranslateTo: 'Übersetzen in',
    translationStart: 'Übersetzung starten',
    translationStop: 'Übersetzung stoppen',
    translationActivateTitle: 'Übersetzung aktivieren',
    translationActivateSubtitle: 'Wähle deine Sprache und die deines Gasts aus und drücke dann auf Starten, um das in Echtzeit übersetzte Gespräch zu beginnen.',
    translationPromptSpeaks: 'spricht',
    translationPromptYouSpeak: 'Du sprichst',
    translationPromptActivate: 'Übersetzung aktivieren',
    translationPromptDismiss: 'Später',
    translationClonedVoiceActive: 'Ihre geklonte Stimme wird verwendet.',
    translationNoClonedVoice: 'Keine geklonte Stimme — eine Standardstimme wird verwendet.',
    translationReRecord: 'Neu aufnehmen',
    translationRecordVoice: 'Stimme aufnehmen',
    translationActiveFast: 'Übersetzung über SeamlessM4T (Server, niedrige Latenz).',
    translationActiveQuality: 'Übersetzung über Deepgram + Cartesia mit Ihrer geklonten Stimme.',
    translationStsOffline: 'STS-Engine offline. Browser-seitige Übersetzung (höhere Latenz).',

    // Control Bar Tooltips
    tooltipMuteMic: 'Mikrofon stummschalten',
    tooltipUnmuteMic: 'Mikrofon aktivieren',
    tooltipSwitchMic: 'Mikrofon wechseln',
    tooltipCameraOff: 'Kamera ausschalten',
    tooltipCameraOn: 'Kamera einschalten',
    tooltipSwitchCamera: 'Kamera wechseln',
    tooltipShareScreen: 'Bildschirm teilen',
    tooltipStopSharing: 'Teilen beenden',
    tooltipTranslation: 'Übersetzung',
    tooltipCloseTranslation: 'Übersetzung schließen',
    tooltipLeaveRoom: 'Raum verlassen',
    tooltipChat: 'Chat',
    tooltipCloseChat: 'Chat schließen',
    tooltipCopied: 'Kopiert!',
    tooltipInvite: 'Jemanden einladen',
    tooltipSubtitlesOn: 'Untertitel ausblenden',
    tooltipSubtitlesOff: 'Untertitel',
    chatNoMessages: 'Keine Nachrichten',
    chatPlaceholder: 'Nachricht eingeben...',
  },
} as const

export type TranslationKey = keyof typeof translations.en
